import products from './products';
import tacHelper from '../state/tac/tacHelpers';
import convert from '../util/aactools/convert';

export default function isValid(pac) {
  const canValidate = pac && pac.model && pac.model.items;
  if (!canValidate) {
    return false;
  }
  const tac = convert.PACtoTAC(pac);
  if (!tac) {
    return false;
  }

  const items = [...tacHelper.getAllItems(tac.items)];
  return items.every(item => !!products.getProduct(item.id));
}
